import apis from '#store/api';
import { Location } from "#root/queries/locations";
import { useQuery } from "@tanstack/react-query";
import { DataCollectionApiResponse } from './types';

export const STATUS_MAP_KEY = 'statusMap';
export const STATUS_MAP_QUERY_KEYS = {
  LOCATIONS: 'locations',
} as const;

export interface StatusMapLocation {
    location: Location;
    activePersonnel: number;
    durationDays: number;
    isIncident: boolean;
}

interface GetStatusMapLocationsParams {
    incidentId?: string;
    locationId?: string;
    groupId?: string;
}

// Fetch status map locations list
export const useStatusMapLocations = (params: GetStatusMapLocationsParams) => {
    return useQuery({
        queryKey: [STATUS_MAP_KEY, STATUS_MAP_QUERY_KEYS.LOCATIONS, params],
        queryFn: async () => {
            const response = await apis.statusMap.getStatusMapLocations({ params });
            return response.data as DataCollectionApiResponse<StatusMapLocation>;
        },
        enabled: !!params.incidentId,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
